import { createRemote } from '../atomic';

export function createInvest(store, data) {
  createRemote(store, 'invest', data);
}
